import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { isString } from 'lodash-es';
import { Typography } from 'antd';

const { Text } = Typography;

const Item = styled.div`
  display: inline-flex;
  flex: 1;
  max-width: 160px;
  height: 26px;
  line-height: 20px;
  padding: 3px 11px;
  cursor: pointer;
  color: var(--fett-content-300);

  &:not(:first-of-type) {
    margin-left: 3px;
  }

  &.f-radio-group-item.checked {
    background: var(--fett-bg-elevated);

    .ant-typography {
      color: var(--ant-primary-color);
    }
  }
`;

const Wrapper = styled.div`
  display: inline-flex;
  max-width: 100%;
  height: 32px;
  padding: 3px 4px;
  background: var(--fett-border-default);

  &.disabled .f-radio-group-item {
    cursor: not-allowed;
    color: var(--fett-text-quaternary);
  }

  &:not(.disabled) .f-radio-group-item:hover {
    background: var(--fett-bg-elevated);
  }
`;

export interface FRadioGroupOption {
  value?: string | number;
  label: string;
  disable?: boolean;
  extra?: React.ReactNode;
}

export interface FRadioGroupProps {
  value: any;
  options: Array<string | FRadioGroupOption>;
  onChange: (value?: string | number) => void;
  disabled?: boolean;
}

const FRadioGroup = (props: FRadioGroupProps) => {
  const { value, options, disabled = false, onChange } = props;

  const isChecked = (optionValue?: string | number) => value === optionValue;
  const handleClick = useCallback(
    (value?: string | number) => {
      if (disabled) return;
      onChange(value);
    },
    [disabled, onChange],
  );

  return (
    <Wrapper className={disabled ? 'disabled' : ''}>
      {options?.map((option) =>
        isString(option) ? (
          <Item
            className={isChecked(option) ? 'checked f-radio-group-item' : 'f-radio-group-item'}
            onClick={() => handleClick(option)}
            key={option}
          >
            {option}
          </Item>
        ) : (
          <Item
            className={
              isChecked(option.value) ? 'checked f-radio-group-item' : 'f-radio-group-item'
            }
            onClick={() => handleClick(option.value)}
            key={option.value}
          >
            <Text ellipsis={{ tooltip: option.label }}>{option.label}</Text>
            {option.extra}
          </Item>
        ),
      )}
    </Wrapper>
  );
};

export default FRadioGroup;
